<div class="container-fluid dashboard-home">
  <div class="row section1 align-items-center">
    <div class="col-12 col-lg-8">
      <div class="home-details">
        <h5 class="home-title">Dashboard</h5>
        <p class="home-subtitle">Operations snapshot for Bhakts admin</p>
      </div>
    </div>
    <div class="col-12 col-lg-4 mt-3 mt-lg-0 text-lg-right">
      <button class="btn btn-primary btn-dashboard px-4" type="button" (click)="loadDashboard()">
        Refresh Data
      </button>
    </div>
  </div>

  <div class="row section1 kpi-grid">
    <div class="col-12 col-md-6 col-xl-3 mb-3">
      <div class="kpi-card">
        <div class="kpi-head">
          <span class="kpi-title">Total Users</span>
          <i class="las la-users"></i>
        </div>
        <h3 class="kpi-value">{{count.totalUsers || 0}}</h3>
        <p class="kpi-foot">All registered users</p>
      </div>
    </div>
    <div class="col-12 col-md-6 col-xl-3 mb-3">
      <div class="kpi-card tone-teal">
        <div class="kpi-head">
          <span class="kpi-title">Bhakts</span>
          <i class="las la-chart-line"></i>
        </div>
        <h3 class="kpi-value">{{count.totalBhakts || 0}}</h3>
        <p class="kpi-foot">Primary user segment</p>
      </div>
    </div>
    <div class="col-12 col-md-6 col-xl-3 mb-3">
      <div class="kpi-card tone-orange">
        <div class="kpi-head">
          <span class="kpi-title">Reviews (24h)</span>
          <i class="las la-award"></i>
        </div>
        <h3 class="kpi-value">{{count.ratingsLast24h || 0}}</h3>
        <p class="kpi-foot">Latest platform activity</p>
      </div>
    </div>
    <div class="col-12 col-md-6 col-xl-3 mb-3">
      <div class="kpi-card">
        <div class="kpi-head">
          <span class="kpi-title">Reviews (24h)</span>
          <i class="las la-clock"></i>
        </div>
        <h3 class="kpi-value">{{count.ratingsLast24h || 0}}</h3>
        <p class="kpi-foot">Recent platform activity</p>
      </div>
    </div>
    <div class="col-12 col-md-6 col-xl-3 mb-3">
      <div class="kpi-card">
        <div class="kpi-head">
          <span class="kpi-title">Entities</span>
          <i class="las la-book"></i>
        </div>
        <h3 class="kpi-value">{{count.totalEntities || 0}}</h3>
        <p class="kpi-foot">Profiles available for review</p>
      </div>
    </div>
    <div class="col-12 col-md-6 col-xl-3 mb-3">
      <div class="kpi-card">
        <div class="kpi-head">
          <span class="kpi-title">Categories</span>
          <i class="las la-layer-group"></i>
        </div>
        <h3 class="kpi-value">{{count.totalCategories || 0}}</h3>
        <p class="kpi-foot">Classification dimensions</p>
      </div>
    </div>
    <div class="col-12 col-md-6 col-xl-3 mb-3">
      <div class="kpi-card">
        <div class="kpi-head">
          <span class="kpi-title">Total Reviews</span>
          <i class="las la-star"></i>
        </div>
        <h3 class="kpi-value">{{count.totalRatings || 0}}</h3>
        <p class="kpi-foot">Lifetime reviews submitted</p>
      </div>
    </div>
    <div class="col-12 col-md-6 col-xl-3 mb-3">
      <div class="kpi-card">
        <div class="kpi-head">
          <span class="kpi-title">News Posts</span>
          <i class="las la-newspaper"></i>
        </div>
        <h3 class="kpi-value">{{count.totalNews || 0}}</h3>
        <p class="kpi-foot">Published news stories</p>
      </div>
    </div>
  </div>

  <div class="row section1">
    <div class="col-12 col-xl-8 mb-3">
      <div class="panel-card">
        <div class="panel-head">
          <h6 class="panel-title">Review Trend (Last 7 Days)</h6>
          <p class="panel-subtitle">Daily review submissions: Bhakts vs total reviews</p>
        </div>
        <div class="panel-body chart-wrap">
          @if (trendData) {
            <p-chart
              height="320"
              type="line"
              [data]="trendData"
            [options]="trendOptions"></p-chart>
          }
          @if (!trendData && !loading) {
            <div class="empty-state">No trend data found.</div>
          }
        </div>
      </div>
    </div>
    <div class="col-12 col-xl-4 mb-3">
      <div class="panel-card">
        <div class="panel-head">
          <h6 class="panel-title">Content Mix</h6>
          <p class="panel-subtitle">Entities, categories and news posts</p>
        </div>
        <div class="panel-body doughnut-wrap">
          @if (usersDoughnutData) {
            <p-chart
              height="300"
              type="doughnut"
              [data]="usersDoughnutData"
            [options]="usersDoughnutOptions"></p-chart>
          }
          @if (!usersDoughnutData && !loading) {
            <div class="empty-state">No user distribution found.</div>
          }
        </div>
      </div>
    </div>
  </div>

  <div class="row section1">
    <div class="col-12 col-xl-4 mb-3">
      <div class="panel-card h-100">
        <div class="panel-head d-flex align-items-center justify-content-between">
          <h6 class="panel-title mb-0">Top Categories</h6>
          <a [routerLink]="['/categories']" class="btn-link">See All</a>
        </div>
        <div class="panel-body pt-0">
          @for (item of categories; track item; let i = $index) {
            <div class="list-row">
              <div class="list-left">
                <span class="list-index">#{{i + 1}}</span>
                <span class="list-name">{{item.name}}</span>
              </div>
              <span class="list-count">{{item.count}}</span>
            </div>
          }
          @if (!categories?.length && !loading) {
            <div class="empty-state">No category data found.</div>
          }
        </div>
      </div>
    </div>

    <div class="col-12 col-xl-4 mb-3">
      <div class="panel-card h-100">
        <div class="panel-head d-flex align-items-center justify-content-between">
          <h6 class="panel-title mb-0">Latest Entities</h6>
          <a [routerLink]="['/entities']" class="btn-link">See All</a>
        </div>
        <div class="panel-body pt-0">
          @for (item of latestEntities; track item) {
            <div class="list-row">
              <div class="list-left">
                <span class="list-name">{{item.name}}</span>
              </div>
              <span class="list-time">{{item.createdAt | date:'mediumDate'}}</span>
            </div>
          }
          @if (!latestEntities?.length && !loading) {
            <div class="empty-state">No entities found.</div>
          }
        </div>
      </div>
    </div>

    <div class="col-12 col-xl-4 mb-3">
      <div class="panel-card h-100">
        <div class="panel-head d-flex align-items-center justify-content-between">
          <h6 class="panel-title mb-0">Quick Actions</h6>
        </div>
        <div class="panel-body pt-2">
          <a class="action-tile" [routerLink]="['/users']">
            <div class="action-icon"><i class="las la-users"></i></div>
            <div class="action-content">
              <h6>Manage Users</h6>
              <p>Moderate users and review account details</p>
            </div>
          </a>
          <a class="action-tile" [routerLink]="['/entities']">
            <div class="action-icon"><i class="las la-book"></i></div>
            <div class="action-content">
              <h6>Manage Entities</h6>
              <p>Create and update entity profiles</p>
            </div>
          </a>
          <a class="action-tile" [routerLink]="['/categories']">
            <div class="action-icon"><i class="las la-layer-group"></i></div>
            <div class="action-content">
              <h6>Manage Categories</h6>
              <p>Maintain category structure and parameters</p>
            </div>
          </a>
          <a class="action-tile" [routerLink]="['/rating-categories']">
            <div class="action-icon"><i class="las la-star"></i></div>
            <div class="action-content">
              <h6>Review Ratings</h6>
              <p>Inspect recent ratings and moderation flow</p>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>

  <div class="row section1">
    <div class="col-12">
      <div class="panel-card">
        <div class="panel-head d-flex align-items-center justify-content-between">
          <h6 class="panel-title mb-0">Recent Reviews</h6>
          <a [routerLink]="['/rating-categories']" class="btn-link">Open Ratings</a>
        </div>
        <div class="panel-body pt-0">
          @for (rating of recentReviews; track rating) {
            <div class="review-row">
              <div class="review-main">
                <p class="review-user">
                  <a [routerLink]="['/users/details', rating.user?.id]">{{rating.user?.fullName}}</a>
                </p>
                <p class="review-entity">
                  <a [routerLink]="['/entities/single-entity', rating.entity?.id]">{{rating.entity?.entityName}}</a>
                </p>
              </div>
              <div class="review-meta">
                <span class="review-score">{{rating.averageRating || 0}}</span>
                <span class="review-time">{{rating.createdAtMs | date:'medium'}}</span>
              </div>
            </div>
          }
          @if (!recentReviews?.length && !loading) {
            <div class="empty-state">No recent reviews found.</div>
          }
        </div>
      </div>
    </div>
  </div>
</div>
